import { TextVariants } from "@src/straps/base/type/Text/Text";
import { ProjectBudgetStatus } from "@src/types";
import StatusNode from "./StatusNode";
import { budgetStatusRenderingOptions } from "../projectRenderingOptions";

export default function BudgetStatusNode({
  budgetStatus,
  textVariant,
}: {
  readonly budgetStatus: ProjectBudgetStatus;
  readonly textVariant?: TextVariants;
}) {
  const { color, label } = budgetStatusRenderingOptions[budgetStatus];
  return (
    <StatusNode
      title={label}
      icon="dot-closed"
      iconColor={color}
      smallIcon
      textVariant={textVariant}
      dataTestId="budget-status-node"
    />
  );
}
